// The only reason why everything is prefixed with '/showcase'
// is to get react url router to play ball with github pages
export default {
    home: '/hackernews/',
    designSystem: '/hackernews/designSystem',
};
